import React, { Component } from 'react';
import { Loader } from 'semantic-ui-react';

class Spinner extends Component {
  render() {
    return (
      <div className="spinner-panel">
        <Loader active>{this.props.message}</Loader>
      </div>
    );
  }
}

export default Spinner;
